interface BadgeProps {
  variant: "vacancy" | "no-vacancy" | "new" | "housing-type";
  children: React.ReactNode;
}

const VARIANT_STYLES = {
  vacancy: "bg-accent/10 text-accent",
  "no-vacancy": "bg-gray-100 text-gray-500",
  new: "bg-green-100 text-green-800",
  "housing-type": "bg-amber-100 text-amber-800",
};

export function Badge({ variant, children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${VARIANT_STYLES[variant]}`}
    >
      {children}
    </span>
  );
}
